<template>
	<transition
			appear
			:appear-active-class="$_slsInpLyt_stylePageLayoutAnimation()">
		<v-row id="_slsInpLyt_top" class="customVRow" no-gutters>
			<v-col>
				<v-stepper
						v-model="stepNumber_"
						class="stepper_"
						:dark="$_slsInpLyt_styleStepperDark"
						:light="$_slsInpLyt_styleStepperLight"
						:vertical="$_slsInpLyt_stateAppIsMobileScreen">
					<!-- stepper header ( only for web ) -->
					<template v-if="!$_slsInpLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-sheet
										class="customVSheet px-3 ma-3"
										:color="$_slsInpLyt_styleStepperSheetColor"
										:dark="$_slsInpLyt_styleStepperSheetDark"
										:elevation="$_slsInpLyt_styleStepperSheetElevation"
										:light="$_slsInpLyt_styleStepperSheetLight">
									<v-stepper-header class="stepperHeader_">
										<v-row>
											<template v-for="(stepVals, stepKey) in step_">
												<v-col :key="stepKey">
													<v-card	class="customVCard"
															:color="$_slsInpLyt_styleStepperHeaderCardColor"
															:dark="$_slsInpLyt_styleStepperHeaderCardDark"
															:elevation="$_slsInpLyt_styleStepperHeaderCardElevation"
															:flat="$_slsInpLyt_styleStepperHeaderCardFlat"
															:hover="$_slsInpLyt_styleStepperHeaderCardHover"
															:light="$_slsInpLyt_styleStepperHeaderCardLight"
															:outlined="$_slsInpLyt_styleStepperHeaderCardOutlined"
															:raised="$_slsInpLyt_styleStepperHeaderCardRaised"
															:tile="$_slsInpLyt_styleStepperHeaderCardTile">
														<v-stepper-step 
																class="stepperStep_"
																:color="$_slsInpLyt_styleStepperStepColor"
																:complete="completed_[stepKey]"
																:step="stepVals.step">
															<span v-html="stepVals.title" />
														</v-stepper-step>
													</v-card>
												</v-col>
											</template>
										</v-row>
									</v-stepper-header>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
					<!-- stepper body ( serial number mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step head (only for mobile) -->
						<template v-if="$_slsInpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperHeaderCardColor"
														:dark="$_slsInpLyt_styleStepperHeaderCardDark"
														:elevation="$_slsInpLyt_styleStepperHeaderCardElevation"
														:flat="$_slsInpLyt_styleStepperHeaderCardFlat"
														:hover="$_slsInpLyt_styleStepperHeaderCardHover"
														:light="$_slsInpLyt_styleStepperHeaderCardLight"
														:outlined="$_slsInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_slsInpLyt_styleStepperHeaderCardRaised"
														:tile="$_slsInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_slsInpLyt_styleStepperStepColor"
															:complete="completed_.serialNumber"
															:step="step_.serialNumber.step">
														<span v-html="step_.serialNumber.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.serialNumber.step">
							<validation-observer v-slot="validationSerialNumber">
								<v-form>
									<template v-if="errorMessage_">
										<v-row>
											<v-col>
												<span v-html="errorMessage_" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<v-col>
											<template v-for="(merchantVals, merchantKey) in $_slsInpLyt_stateUserSales">
												<v-row :key="`product-${merchantKey}`">
													<v-col>
														<v-sheet
																class="customVSheet px-3 ma-3"
																:color="$_slsInpLyt_styleStepperSheetColor"
																:dark="$_slsInpLyt_styleStepperSheetDark"
																:elevation="$_slsInpLyt_styleStepperSheetElevation"
																:light="$_slsInpLyt_styleStepperSheetLight">
															<template v-for="(productVals, productKey) in merchantVals.addedProduct">
																<template v-if="productVals.amount > 0">
																	<v-row :key="productKey">
																		<v-col>
																			<v-card class="customVCard"
																					:color="$_slsInpLyt_styleStepperBodyCardColor"
																					:dark="$_slsInpLyt_styleStepperBodyCardDark"
																					:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																					:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																					:hover="$_slsInpLyt_styleStepperBodyCardHover"
																					:light="$_slsInpLyt_styleStepperBodyCardLight"
																					:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																					:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																					:tile="$_slsInpLyt_styleStepperBodyCardTile">
																				<v-row>
																					<template v-if="isObject(productVals.image)">
																						<v-col cols="12" md="4" class="center">
																							<v-img	class="customVImg"
																									:src="$_slsInpLyt_styleProductImageUrl(productVals)" />
																						</v-col>
																					</template>
																					<v-col>
																						<v-row no-gutters>
																							<v-col>
																								<v-card-title>
																									<v-row no-gutters>
																										<v-col>
																											<span	class="title"
																													v-html="productVals.title" />
																										</v-col>
																									</v-row>
																								</v-card-title>
																								<v-card-text>
																									<v-row no-gutters>
																										<v-col>
																											<span 	class="subtitle-1"
																													v-html="productVals.code" />
																										</v-col>
																									</v-row>
																								</v-card-text>
																								<v-card-text class="cardText_">
																									<v-row dense align="end">
																										<v-col cols="2">
																											<v-text-field 
																													hide-details 
																													v-model="$store.state.user.sales[merchantKey].addedProduct[productKey].amount"/>
																										</v-col>
																										<v-col class="py-2" cols="auto">
																											<span>*</span>
																										</v-col>
																										<v-col cols="2">
																											<v-text-field 
																													hide-details 
																													:value="productVals.price"/>
																										</v-col>
																										<v-col class="py-2" cols="auto">
																											<span>=</span>
																										</v-col>
																										<v-col>
																											<v-text-field 
																													hide-details
																													:value="productVals.amount * productVals.price"/>
																										</v-col>
																									</v-row>
																								</v-card-text>
																							</v-col>
																						</v-row>
																					</v-col>
																				</v-row>
																			</v-card>
																		</v-col>
																	</v-row>
																</template>
															</template>
														</v-sheet>
													</v-col>
												</v-row>
												<v-row :key="`serialNumber-${merchantKey}`">
													<v-col>
														<v-sheet
																class="customVSheet px-3 ma-3"
																:color="$_slsInpLyt_styleStepperSheetColor"
																:dark="$_slsInpLyt_styleStepperSheetDark"
																:elevation="$_slsInpLyt_styleStepperSheetElevation"
																:light="$_slsInpLyt_styleStepperSheetLight">
															<template v-for="(serialNumberVals, serialNumberKey) in merchantVals.addedSerialNumber">
																<v-row :key="serialNumberKey">
																	<v-col>
																		<v-card class="customVCard"
																				:color="$_slsInpLyt_styleStepperBodyCardColor"
																				:dark="$_slsInpLyt_styleStepperBodyCardDark"
																				:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																				:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																				:hover="$_slsInpLyt_styleStepperBodyCardHover"
																				:light="$_slsInpLyt_styleStepperBodyCardLight"
																				:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																				:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																				:tile="$_slsInpLyt_styleStepperBodyCardTile">
																			<v-row>
																				<template v-if="isObject(serialNumberVals.image)">
																					<v-col cols="12" md="4" class="center">
																						<v-img	class="customVImg"
																								:src="$_slsInpLyt_styleProductImageUrl(serialNumberVals)" />
																					</v-col>
																				</template>
																				<v-col>
																					<v-row no-gutters>
																						<v-col>
																							<v-card-title>
																								<v-row no-gutters>
																									<v-col>
																										<span	class="title"
																												v-html="serialNumberVals.title" />
																									</v-col>
																								</v-row>
																							</v-card-title>
																							<v-card-text>
																								<v-row no-gutters>
																									<v-col>
																										<span 	class="subtitle-1"
																												v-html="serialNumberVals.code" />
																									</v-col>
																								</v-row>
																							</v-card-text>
																							<v-card-text class="cardText_">
																								<v-row dense align="end">
																									<v-col cols="2">
																										<v-text-field 
																												disabled
																												hide-details 
																												:value="1"/>
																									</v-col>
																									<v-col class="py-2" cols="auto">
																										<span>*</span>
																									</v-col>
																									<v-col cols="2">
																										<v-text-field 
																												disabled
																												hide-details 
																												:value="serialNumberVals.price"/>
																									</v-col>
																									<v-col class="py-2" cols="auto">
																										<span>=</span>
																									</v-col>
																									<v-col>
																										<v-text-field 
																												disabled
																												hide-details
																												:value="serialNumberVals.price"/>
																									</v-col>
																								</v-row>
																							</v-card-text>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																		</v-card>
																	</v-col>
																</v-row>
															</template>
														</v-sheet>
													</v-col>
												</v-row>
											</template>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<v-col cols="auto">
											<v-btn	class="customVBtn"

													:disabled="!validationSerialNumber.passed && !validationSerialNumbervalid"

													:block="$_slsInpLyt_styleStepperActionButtonBlock"
													:color="$_slsInpLyt_styleStepperActionButtonColorSubmit"
													:dark="!validationSerialNumber.passed && !validationSerialNumbervalid ? $_slsInpLyt_stateAppIsDarkTheme : $_slsInpLyt_styleStepperActionButtonDark"
													:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
													:large="$_slsInpLyt_styleStepperActionButtonLarge"
													:light="$_slsInpLyt_styleStepperActionButtonLight"
													:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
													:small="$_slsInpLyt_styleStepperActionButtonSmall"
													:text="$_slsInpLyt_styleStepperActionButtonFlat"

													@click="$_slsInpLyt_next()"
													v-text="$_slsInpLyt_langNextButton" />
										</v-col>
									</v-row>
								</v-form>
							</validation-observer>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( input mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step head (only for mobile) -->
						<template v-if="$_slsInpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperHeaderCardColor"
														:dark="$_slsInpLyt_styleStepperHeaderCardDark"
														:elevation="$_slsInpLyt_styleStepperHeaderCardElevation"
														:flat="$_slsInpLyt_styleStepperHeaderCardFlat"
														:hover="$_slsInpLyt_styleStepperHeaderCardHover"
														:light="$_slsInpLyt_styleStepperHeaderCardLight"
														:outlined="$_slsInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_slsInpLyt_styleStepperHeaderCardRaised"
														:tile="$_slsInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_slsInpLyt_styleStepperStepColor"
															:complete="completed_.input"
															:step="step_.input.step">
														<span v-html="step_.input.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.input.step">
							<validation-observer v-slot="validationInput">
								<v-form>
									<template v-if="errorMessage_">
										<v-row>
											<v-col>
												<span v-html="errorMessage_" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_slsInpLyt_styleStepperSheetColor"
													:dark="$_slsInpLyt_styleStepperSheetDark"
													:elevation="$_slsInpLyt_styleStepperSheetElevation"
													:light="$_slsInpLyt_styleStepperSheetLight">
												<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
													<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
														<template v-if="contentVals.title">
															<v-row :key="`title-${contentKey}`">
																<v-col>
																	<v-card class="customVCard"
																			:color="$_slsInpLyt_styleStepperBodyCardColor"
																			:dark="$_slsInpLyt_styleStepperBodyCardDark"
																			:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																			:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																			:hover="$_slsInpLyt_styleStepperBodyCardHover"
																			:light="$_slsInpLyt_styleStepperBodyCardLight"
																			:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																			:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																			:tile="$_slsInpLyt_styleStepperBodyCardTile">
																		<v-card-text>
																			<v-row dense>
																				<v-col>
																					<span	class="title"
																							v-html="$_slsInpLyt_langContentTitle(contentVals)" />
																				</v-col>
																			</v-row>
																		</v-card-text>
																	</v-card>
																</v-col>
															</v-row>
														</template>
														<v-row :key="`content-${contentKey}`">
															<v-col>
																<v-card class="customVCard"
																		:color="$_slsInpLyt_styleStepperBodyCardColor"
																		:dark="$_slsInpLyt_styleStepperBodyCardDark"
																		:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																		:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																		:hover="$_slsInpLyt_styleStepperBodyCardHover"
																		:light="$_slsInpLyt_styleStepperBodyCardLight"
																		:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																		:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																		:tile="$_slsInpLyt_styleStepperBodyCardTile">
																	<template v-if="isObject(contentVals.bigImage)">
																		<v-row>
																			<v-col>
																				<v-img	class="customVImg"
																						:src="$_slsInpLyt_styleContentBigImageUrl(contentVals)" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-if="isObject(contentVals.video)">
																		<v-row>
																			<v-col>
																				<card-video
																						:contentKey="contentKey"
																						:contents="contents"
																						:inits="inits" />
																			</v-col>
																		</v-row>
																	</template>
																	<v-row>
																		<template v-if="contentVals.text">
																			<v-col>
																				<v-card-title>
																					<v-row no-gutters>
																						<v-col>
																							<span 	class="subtitle-1"
																									v-html="$_slsInpLyt_langContentText(contentVals)" />
																						</v-col>
																					</v-row>
																				</v-card-title>
																			</v-col>
																		</template>
																		<template v-if="isObject(contentVals.image)">
																			<v-col cols="12" md="4" class="center">
																				<v-img	class="customVImg"
																						:src="$_slsInpLyt_styleContentImageUrl(contentVals)" />
																			</v-col>
																		</template>
																	</v-row>
																	<v-row>
																		<v-col>
																			<v-card-text>
																				<!-- check box -->
																				<template v-if="contentVals.type.checkbox">
																					<v-row no-gutters>
																						<v-col>
																							<input-checkbox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox -->
																				<template v-if="contentVals.type.combobox">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox multiple -->
																				<template v-if="contentVals.type.comboboxMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- date picker -->
																				<template v-if="contentVals.type.datePicker">
																					<v-row no-gutters>
																						<v-col>
																							<input-date-picker
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- radio button -->
																				<template v-if="contentVals.type.radioButton">
																					<v-row no-gutters>
																						<v-col>
																							<input-radio-button
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select -->
																				<template v-if="contentVals.type.select">
																					<v-row no-gutters>
																						<v-col>
																							<input-select
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select multiple -->
																				<template v-if="contentVals.type.selectMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-select-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- slider -->
																				<template v-if="contentVals.type.slider">
																					<v-row no-gutters>
																						<v-col>
																							<input-slider
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- switch -->
																				<template v-if="contentVals.type.switch">
																					<v-row no-gutters>
																						<v-col>
																							<input-switch
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- textarea -->
																				<template v-if="contentVals.type.textarea">
																					<v-row no-gutters>
																						<v-col>
																							<input-textarea
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- text field -->
																				<template v-if="contentVals.type.textField">
																					<v-row no-gutters>
																						<v-col>
																							<input-text-field
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																			</v-card-text>
																		</v-col>
																	</v-row>
																	<!-- action buttons --> 
																	<template v-if="!isEmpty(contentVals.actionButtons)">
																		<v-row>
																			<v-col>
																				<v-card-actions>
																					<v-row dense>
																						<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																							<v-col :key="actionButtonKey" cols="auto">
																								<v-btn	class="customVBtn"
																										:block="$_slsInpLyt_styleQuestionActionButtonBlock"
																										:color="$_slsInpLyt_styleQuestionActionButtonColor"
																										:dark="$_slsInpLyt_styleQuestionActionButtonDark"
																										:depressed="$_slsInpLyt_styleQuestionActionButtonDepressed"
																										:elevation="$_slsInpLyt_styleQuestionActionButtonElevation"
																										:large="$_slsInpLyt_styleQuestionActionButtonLarge"
																										:light="$_slsInpLyt_styleQuestionActionButtonLight"
																										:outlined="$_slsInpLyt_styleQuestionActionButtonOutlined"
																										:rounded="$_slsInpLyt_styleQuestionActionButtonRounded"
																										:small="$_slsInpLyt_styleQuestionActionButtonSmall"
																										:text="$_slsInpLyt_styleQuestionActionButtonFlat"
																										@click="openLink(actionButtonVals.link)"
																										v-text="$_slsInpLyt_langActionButtonTitle(actionButtonVals)" />
																							</v-col>
																						</template>
																					</v-row>
																				</v-card-actions>
																			</v-col>
																		</v-row>
																	</template>
																</v-card>
															</v-col>
														</v-row>
													</template>
												</template>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<!-- back button -->
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_slsInpLyt_styleStepperActionButtonBlock"
													:color="$_slsInpLyt_styleStepperActionButtonColorSubmit"
													:dark="$_slsInpLyt_styleStepperActionButtonDark"
													:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
													:large="$_slsInpLyt_styleStepperActionButtonLarge"
													:light="$_slsInpLyt_styleStepperActionButtonLight"
													:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
													:small="$_slsInpLyt_styleStepperActionButtonSmall"
													:text="$_slsInpLyt_styleStepperActionButtonFlat"
													@click="$_slsInpLyt_backToSerialNumber()"
													v-text="$_slsInpLyt_langBackButton" />
										</v-col>
										<!-- submit button -->
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_slsInpLyt_styleStepperActionButtonBlock"
													:color="$_slsInpLyt_styleStepperActionButtonColorSubmit"
													:dark="!validationInput.passed && !validationInput.valid ? $_slsInpLyt_stateAppIsDarkTheme : $_slsInpLyt_styleStepperActionButtonDark"
													:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
													:large="$_slsInpLyt_styleStepperActionButtonLarge"
													:light="$_slsInpLyt_styleStepperActionButtonLight"
													:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
													:small="$_slsInpLyt_styleStepperActionButtonSmall"
													:text="$_slsInpLyt_styleStepperActionButtonFlat"

													:disabled="!validationInput.passed && !validationInput.valid"

													@click="$_slsInpLyt_submit()"
													v-text="$_slsInpLyt_langSubmitButton" />
										</v-col>
									</v-row>
								</v-form>
							</validation-observer>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( submit mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_slsInpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperHeaderCardColor"
														:dark="$_slsInpLyt_styleStepperHeaderCardDark"
														:elevation="$_slsInpLyt_styleStepperHeaderCardElevation"
														:flat="$_slsInpLyt_styleStepperHeaderCardFlat"
														:hover="$_slsInpLyt_styleStepperHeaderCardHover"
														:light="$_slsInpLyt_styleStepperHeaderCardLight"
														:outlined="$_slsInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_slsInpLyt_styleStepperHeaderCardRaised"
														:tile="$_slsInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_slsInpLyt_styleStepperStepColor"
															:complete="completed_.submit"
															:step="step_.submit.step">
														<span v-html="step_.submit.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.submit.step">
							<template v-for="(merchantVals, merchantKey) in $_slsInpLyt_stateUserSales">
								<v-row :key="`product-${merchantKey}`">
									<v-col>
										<v-sheet
												class="customVSheet px-3 ma-3"
												:color="$_slsInpLyt_styleStepperSheetColor"
												:dark="$_slsInpLyt_styleStepperSheetDark"
												:elevation="$_slsInpLyt_styleStepperSheetElevation"
												:light="$_slsInpLyt_styleStepperSheetLight">
											<template v-for="(productVals, productKey) in merchantVals.addedProduct">
												<template v-if="productVals.amount > 0">
													<v-row :key="productKey">
														<v-col>
															<v-card class="customVCard"
																	:color="$_slsInpLyt_styleStepperBodyCardColor"
																	:dark="$_slsInpLyt_styleStepperBodyCardDark"
																	:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																	:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																	:hover="$_slsInpLyt_styleStepperBodyCardHover"
																	:light="$_slsInpLyt_styleStepperBodyCardLight"
																	:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																	:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																	:tile="$_slsInpLyt_styleStepperBodyCardTile">
																<v-row>
																	<template v-if="isObject(productVals.image)">
																		<v-col cols="12" md="4" class="center">
																			<v-img	class="customVImg"
																					:src="$_slsInpLyt_styleProductImageUrl(productVals)" />
																		</v-col>
																	</template>
																	<v-col>
																		<v-row no-gutters>
																			<v-col>
																				<v-card-title>
																					<v-row no-gutters>
																						<v-col>
																							<span	class="title"
																									v-html="productVals.title" />
																						</v-col>
																					</v-row>
																				</v-card-title>
																				<v-card-text>
																					<v-row no-gutters>
																						<v-col>
																							<span 	class="subtitle-1"
																									v-html="productVals.code" />
																						</v-col>
																					</v-row>
																				</v-card-text>
																				<v-card-text class="cardText_">
																					<v-row dense align="end">
																						<v-col cols="auto">
																							<span v-text="productVals.amount"/>
																						</v-col>
																						<v-col cols="auto">
																							<span>*</span>
																						</v-col>
																						<v-col cols="auto">
																							<span v-text="productVals.price"/>
																						</v-col>
																						<v-col cols="auto">
																							<span>=</span>
																						</v-col>
																						<v-col>
																							<span v-text="productVals.amount * productVals.price"/>
																						</v-col>
																					</v-row>
																				</v-card-text>
																			</v-col>
																		</v-row>
																	</v-col>
																</v-row>
															</v-card>
														</v-col>
													</v-row>
												</template>
											</template>
										</v-sheet>
									</v-col>
								</v-row>
								<v-row :key="`serialNumber-${merchantKey}`">
									<v-col>
										<v-sheet
												class="customVSheet px-3 ma-3"
												:color="$_slsInpLyt_styleStepperSheetColor"
												:dark="$_slsInpLyt_styleStepperSheetDark"
												:elevation="$_slsInpLyt_styleStepperSheetElevation"
												:light="$_slsInpLyt_styleStepperSheetLight">
											<template v-for="(serialNumberVals, serialNumberKey) in merchantVals.addedSerialNumber">
												<v-row :key="serialNumberKey">
													<v-col>
														<v-card class="customVCard"
																:color="$_slsInpLyt_styleStepperBodyCardColor"
																:dark="$_slsInpLyt_styleStepperBodyCardDark"
																:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																:hover="$_slsInpLyt_styleStepperBodyCardHover"
																:light="$_slsInpLyt_styleStepperBodyCardLight"
																:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																:tile="$_slsInpLyt_styleStepperBodyCardTile">
															<v-row>
																<template v-if="isObject(serialNumberVals.image)">
																	<v-col cols="12" md="4" class="center">
																		<v-img	class="customVImg"
																				:src="$_slsInpLyt_styleProductImageUrl(serialNumberVals)" />
																	</v-col>
																</template>
																<v-col>
																	<v-row no-gutters>
																		<v-col>
																			<v-card-title>
																				<v-row no-gutters>
																					<v-col>
																						<span	class="title"
																								v-html="serialNumberVals.title" />
																					</v-col>
																				</v-row>
																			</v-card-title>
																			<v-card-text>
																				<v-row no-gutters>
																					<v-col>
																						<span 	class="subtitle-1"
																								v-html="serialNumberVals.code" />
																					</v-col>
																				</v-row>
																			</v-card-text>
																			<v-card-text class="cardText_">
																				<v-row dense align="end">
																					<v-col cols="auto">
																						<span v-text="1"/>
																					</v-col>
																					<v-col cols="auto">
																						<span>*</span>
																					</v-col>
																					<v-col cols="auto">
																						<span v-text="serialNumberVals.price"/>
																					</v-col>
																					<v-col cols="auto">
																						<span>=</span>
																					</v-col>
																					<v-col>
																						<span v-text="serialNumberVals.price"/>
																					</v-col>
																				</v-row>
																			</v-card-text>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-card>
													</v-col>
												</v-row>
											</template>
										</v-sheet>
									</v-col>
								</v-row>
							</template>
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperBodyCardColor"
														:dark="$_slsInpLyt_styleStepperBodyCardDark"
														:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
														:flat="$_slsInpLyt_styleStepperBodyCardFlat"
														:hover="$_slsInpLyt_styleStepperBodyCardHover"
														:light="$_slsInpLyt_styleStepperBodyCardLight"
														:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
														:raised="$_slsInpLyt_styleStepperBodyCardRaised"
														:tile="$_slsInpLyt_styleStepperBodyCardTile">
													<v-card-title>
														<v-row no-gutters>
															<v-col>
																<span	class="title"
																		v-html="$_slsInpLyt_langTotal" />
															</v-col>
														</v-row>
													</v-card-title>
													<v-card-text class="cardText_">
														<v-row dense align="end">
															<v-col cols="2">
																<span v-html="$_slsInpLyt_langSubTotal"/>
															</v-col>
															<v-col>
																<span v-text="subTotal_"/>
															</v-col>
														</v-row>
														<v-row dense align="end">
															<v-col cols="2">
																<span v-html="$_slsInpLyt_langTax"/>
															</v-col>
															<v-col>
																<span v-text="tax_"/>
															</v-col>
														</v-row>
														<v-row dense align="end">
															<v-col cols="2">
																<span v-html="$_slsInpLyt_langTotal"/>
															</v-col>
															<v-col>
																<span v-text="total_"/>
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<template v-for="(answerVals, answerKey) in sortObject($_slsInpLyt_stateInputData, 'order')">
											<template v-if="answerVals.question.title">
												<v-row :key="`title-${answerKey}`">
													<v-col>
														<v-card class="customVCard"
																:color="$_slsInpLyt_styleStepperBodyCardColor"
																:dark="$_slsInpLyt_styleStepperBodyCardDark"
																:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
																:flat="$_slsInpLyt_styleStepperBodyCardFlat"
																:hover="$_slsInpLyt_styleStepperBodyCardHover"
																:light="$_slsInpLyt_styleStepperBodyCardLight"
																:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
																:raised="$_slsInpLyt_styleStepperBodyCardRaised"
																:tile="$_slsInpLyt_styleStepperBodyCardTile">
															<v-card-text>
																<v-row dense>
																	<v-col>
																		<span	class="title"
																				v-html="answerVals.question.title" />
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</template>
											<v-row :key="`content-${answerKey}`">
												<v-col>
													<v-card class="customVCard"
															:color="$_slsInpLyt_styleStepperBodyCardColor"
															:dark="$_slsInpLyt_styleStepperBodyCardDark"
															:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
															:flat="$_slsInpLyt_styleStepperBodyCardFlat"
															:hover="$_slsInpLyt_styleStepperBodyCardHover"
															:light="$_slsInpLyt_styleStepperBodyCardLight"
															:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
															:raised="$_slsInpLyt_styleStepperBodyCardRaised"
															:tile="$_slsInpLyt_styleStepperBodyCardTile">
														<v-card-title>
															<v-row dense>
																<v-col>
																	<span	class="subtitle-1"
																			v-html="answerVals.question.text" />
																</v-col>
															</v-row>
														</v-card-title>
														<v-card-text>
															<template v-if="answerVals.type == 'checkbox' || answerVals.type == 'switch'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="vals.value">
																			<v-col :key="key" cols="auto">
																				<span v-html="vals.text" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'combobox'">
																<v-row dense>
																	<v-col cols="auto">
																		<template v-if="isObject(answerVals.answer)">
																			<span v-html="answerVals.answer.text" />
																		</template>
																		<template v-else>
																			<span v-html="answerVals.answer" />
																		</template>
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'comboboxMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="isObject(vals)">
																			<v-col :key="key" cols="auto">
																				<span v-html="vals.text" />
																			</v-col>
																		</template>
																		<template v-else>
																			<v-col :key="key" cols="auto">
																				<span v-html="vals" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'radioButton' || answerVals.type == 'select'">
																<v-row dense>
																	<v-col cols="auto">
																		<span v-html="answerVals.answer.text" />
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'selectMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<v-col :key="key" cols="auto">
																			<span v-html="vals.text" />
																		</v-col>
																	</template>
																</v-row>
															</template>
															<template v-else>
																<v-row dense>
																	<v-col cols="auto">
																		<span v-html="answerVals.answer" />
																	</v-col>
																</v-row>
															</template>
														</v-card-text>
													</v-card>
												</v-col>
											</v-row>
										</template>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- back button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_slsInpLyt_styleStepperActionButtonBlock"
											:color="$_slsInpLyt_styleStepperActionButtonColorBack"
											:dark="$_slsInpLyt_styleStepperActionButtonDark"
											:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
											:large="$_slsInpLyt_styleStepperActionButtonLarge"
											:light="$_slsInpLyt_styleStepperActionButtonLight"
											:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
											:small="$_slsInpLyt_styleStepperActionButtonSmall"
											:text="$_slsInpLyt_styleStepperActionButtonFlat"
											@click="$_slsInpLyt_backToInput()"
											v-text="$_slsInpLyt_langBackButton" />
								</v-col>
								<!-- confirm button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_slsInpLyt_styleStepperActionButtonBlock"
											:color="$_slsInpLyt_styleStepperActionButtonColorConfirm"
											:dark="$_slsInpLyt_styleStepperActionButtonDark"
											:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
											:large="$_slsInpLyt_styleStepperActionButtonLarge"
											:light="$_slsInpLyt_styleStepperActionButtonLight"
											:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
											:small="$_slsInpLyt_styleStepperActionButtonSmall"
											:text="$_slsInpLyt_styleStepperActionButtonFlat"
											@click="$_slsInpLyt_confirm()">
										<template v-if="onProgress_">
											<progress-circular />
										</template>
										<template v-else>
											<span v-text="$_slsInpLyt_langConfirmButton" />
										</template>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( finish mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_slsInpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperHeaderCardColor"
														:dark="$_slsInpLyt_styleStepperHeaderCardDark"
														:elevation="$_slsInpLyt_styleStepperHeaderCardElevation"
														:flat="$_slsInpLyt_styleStepperHeaderCardFlat"
														:hover="$_slsInpLyt_styleStepperHeaderCardHover"
														:light="$_slsInpLyt_styleStepperHeaderCardLight"
														:outlined="$_slsInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_slsInpLyt_styleStepperHeaderCardRaised"
														:tile="$_slsInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_slsInpLyt_styleStepperStepColor"
															:complete="completed_.finish"
															:step="step_.finish.step">
														<span v-html="step_.finish.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.finish.step">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_slsInpLyt_styleStepperSheetColor"
											:dark="$_slsInpLyt_styleStepperSheetDark"
											:elevation="$_slsInpLyt_styleStepperSheetElevation"
											:light="$_slsInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_slsInpLyt_styleStepperBodyCardColor"
														:dark="$_slsInpLyt_styleStepperBodyCardDark"
														:elevation="$_slsInpLyt_styleStepperBodyCardElevation"
														:flat="$_slsInpLyt_styleStepperBodyCardFlat"
														:hover="$_slsInpLyt_styleStepperBodyCardHover"
														:light="$_slsInpLyt_styleStepperBodyCardLight"
														:outlined="$_slsInpLyt_styleStepperBodyCardOutlined"
														:raised="$_slsInpLyt_styleStepperBodyCardRaised"
														:tile="$_slsInpLyt_styleStepperBodyCardTile">
													<v-card-text>
														<v-row dense>
															<v-col>
																<span 	class="title"
																		v-html="$_slsInpLyt_langFinishedText" />
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- ok button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_slsInpLyt_styleStepperActionButtonBlock"
											:color="$_slsInpLyt_styleStepperActionButtonColorFinish"
											:dark="$_slsInpLyt_styleStepperActionButtonDark"
											:depressed="$_slsInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_slsInpLyt_styleStepperActionButtonElevation"
											:large="$_slsInpLyt_styleStepperActionButtonLarge"
											:light="$_slsInpLyt_styleStepperActionButtonLight"
											:outlined="$_slsInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_slsInpLyt_styleStepperActionButtonRounded"
											:small="$_slsInpLyt_styleStepperActionButtonSmall"
											:text="$_slsInpLyt_styleStepperActionButtonFlat"
											@click="openLink($_slsInpLyt_linkOkButton)"
											v-text="$_slsInpLyt_langOkButton" />
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'SalesInputLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				valid_: true,

				errorMessage_: null,
				onProgress_: false,

				stepNumber_: 1,

				mode_: {
					serialNumber: true,
					input: false,
					submit: false,
					finish: false
				},

				completed_: {
					serialNumber: false,
					input: false,
					submit: false,
					finish: false
				},

				step_: {
					serialNumber: {
						step: 1,
						title: 'Serial Number'
					},
					input: {
						step: 2,
						title: 'Input'
					},
					submit: {
						step: 3,
						title: 'Submit'
					},
					finish: {
						step: 4,
						title: 'Finished'
					}
				},

				subTotal_: 0,
				tax_: 0,
				total_: 0
			}
		},
		computed: {
			// params
			$_slsInpLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_slsInpLyt_paramsMerchantId() {
				const self_ = this;
				const params_ = self_.$_slsInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.merchantId
			},
			// current user
			$_slsInpLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_slsInpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_slsInpLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_slsInpLyt_stateInput() {
				const self_ = this;
				return self_.getInputState()
			},
			$_slsInpLyt_stateInputData() {
				const self_ = this;
				const input_ = self_.$_slsInpLyt_stateInput;
				if(self_.isFalse(input_)) { return null }
				return input_.data
			},
			$_slsInpLyt_stateUserSales() {
				const self_ = this;
				return self_.getUserState('sales')
			},
			// info
			$_slsInpLyt_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'contact')
			},
			$_slsInpLyt_infoContactUid() {
				const self_ = this;
				const contact_ = self_.$_slsInpLyt_infoContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.uid
			},
			$_slsInpLyt_infoMessage() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'message')
			},
			// lang
			$_slsInpLyt_langNextButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputNextButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputBackButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputSubmitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputConfirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langFinishedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputFinishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberInputOkButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langSubTotal() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberSubTotal')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langTax() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberTax')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_slsInpLyt_langTotal() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'serialNumberTotal')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_slsInpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_slsInpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_slsInpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// link
			$_slsInpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'serialNumberInputOkButton')
			},
			// style
			$_slsInpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_slsInpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_slsInpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_slsInpLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputStepper')
			},
			$_slsInpLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_slsInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_slsInpLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_slsInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_slsInpLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_slsInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_slsInpLyt_styleStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputStepperSheet')
			},
			$_slsInpLyt_styleStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_slsInpLyt_styleStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_slsInpLyt_styleStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_slsInpLyt_styleStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_slsInpLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputStepperHeaderCard')
			},
			$_slsInpLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_slsInpLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_slsInpLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_slsInpLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_slsInpLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_slsInpLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_slsInpLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_slsInpLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_slsInpLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_slsInpLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputStepperBodyCard')
			},
			$_slsInpLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_slsInpLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_slsInpLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_slsInpLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_slsInpLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_slsInpLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_slsInpLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_slsInpLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_slsInpLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_slsInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_slsInpLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputStepperActionButton')
			},
			$_slsInpLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_slsInpLyt_styleStepperActionButtonColorSubmit() {
				const self_ = this;
				const actionButton_ =self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.submit) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_slsInpLyt_styleStepperActionButtonColorBack() {
				const self_ = this;
				const actionButton_ =self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.back) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_slsInpLyt_styleStepperActionButtonColorConfirm() {
				const self_ = this;
				const actionButton_ =self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.confirm) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_slsInpLyt_styleStepperActionButtonColorFinish() {
				const self_ = this;
				const actionButton_ =self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.finish) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_slsInpLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_slsInpLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_slsInpLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_slsInpLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_slsInpLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_slsInpLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_slsInpLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_slsInpLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_slsInpLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_slsInpLyt_styleQuestionActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'serialNumberInputQuestionActionButton')
			},
			$_slsInpLyt_styleQuestionActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_slsInpLyt_styleQuestionActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_slsInpLyt_styleQuestionActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_slsInpLyt_styleQuestionActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_slsInpLyt_styleQuestionActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_slsInpLyt_styleQuestionActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_slsInpLyt_styleQuestionActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_slsInpLyt_styleQuestionActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_slsInpLyt_styleQuestionActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_slsInpLyt_styleQuestionActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_slsInpLyt_styleQuestionActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_slsInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_slsInpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_slsInpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_slsInpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			// (product)
			$_slsInpLyt_styleProductImage() {
				return productVals => {
					return productVals.image
				}
			},
			$_slsInpLyt_styleProductImageUrl() {
				const self_ = this;
				return productVals => {
					const image_ = self_.$_slsInpLyt_styleProductImage(productVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		watch: {
			currentTime_: '$_slsInpLyt_checkTime'
		},
		created() {
			const self_ = this;

			// set initial input status
			self_.$_slsInpLyt_setInputState()
		},
		methods: {
			$_slsInpLyt_setInputState() {
				const self_ = this;

				self_.$_slsInpLyt_setInputUser()
				self_.$_slsInpLyt_setInputContact()
				self_.$_slsInpLyt_setInputPageInfo()
				self_.$_slsInpLyt_setInputData()
			},
			$_slsInpLyt_setInputUser(){
				const self_ = this;

				const uid_ = self_.$_slsInpLyt_currentUserUid;
				
				let user_ = {}
				user_[uid_] = true;

				self_.setInputState('user', user_)
			},
			$_slsInpLyt_setInputContact(){
				const self_ = this;

				const uid_ = self_.$_slsInpLyt_infoContactUid;
				
				let contact_ = {}
				contact_[uid_] = true;

				self_.setInputState('contact', contact_)
			},
			$_slsInpLyt_setInputPageInfo(){
				const self_ = this;

				const name_ = self_.getPageState('name')
				const type_ = self_.getPageState('type')
				
				let page_ = {}
				page_.name = name_;
				page_.type = type_;

				self_.setInputState('pageInfo', page_)
			},
			$_slsInpLyt_setInputData() {
				const self_ = this;

				let data_ = {}
				let options_ = {}

				Object.keys(self_.contents).forEach(key => {
					data_[key] = {}

					// order
					data_[key].order = self_.contents[key].order;

					// question title & text
					data_[key].question = {}
					data_[key].question.title = self_.$_slsInpLyt_langContentTitle(self_.contents[key])
					data_[key].question.text = self_.$_slsInpLyt_langContentText(self_.contents[key])

					// type
					Object.keys(self_.contents[key].type).forEach(typeKey => {
						if(self_.contents[key].type[typeKey]) { data_[key].type = typeKey }
					})

					// default answer (empty or zero)
					if(		self_.contents[key].type.combobox || // (free text)
							self_.contents[key].type.datePicker || 
							self_.contents[key].type.textarea || 
							self_.contents[key].type.textField ) { 
						data_[key].answer = '';
					} else if(	self_.contents[key].type.slider ) { 
						data_[key].answer = 0
					} else if(	self_.contents[key].type.comboboxMultiple || 
								self_.contents[key].type.selectMultiple ) { 
						data_[key].answer = [] 
					} else if(	self_.contents[key].type.checkbox || 
								self_.contents[key].type.switch ) { 
						data_[key].answer = {}

						options_ = self_.contents[key].options

						Object.keys(options_).forEach(optionKey => {
							data_[key].answer[optionKey] = {
								value: false,
								order: options_[optionKey].order,
								text: options_[optionKey].text,
								isCorrectAnswer: options_[optionKey].isCorrectAnswer
							}
						})
					} else { // radio, combobox (select option), select
						data_[key].answer = {}
					}	

					// score
					data_[key].score = self_.contents[key].score;
				})

				self_.setInputState('data', data_)

				return
			},
			$_slsInpLyt_next() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						serialNumber: false,
						input: true,
						submit: false,
						finish: false
					}

					self_.completed_ = { 
						serialNumber: true,
						input: false,
						submit: false,
						finish: false
					}

					self_.stepNumber_++;
					
					self_.$_slsInpLyt_calcTotal()

					return
				}).then(() => {
					vuetify_.goTo('#_slsInpLyt_top')
				})
			},
			$_slsInpLyt_backToSerialNumber() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						serialNumber: true,
						input: false,
						submit: false,
						finish: false
					}

					self_.completed_ = { 
						serialNumber: false,
						input: false,
						submit: false,
						finish: false
					}

					self_.stepNumber_--;

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_slsInpLyt_top')
				})
			},
			$_slsInpLyt_backToInput() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						serialNumber: false,
						input: true,
						submit: false,
						finish: false
					}

					self_.completed_ = { 
						serialNumber: true,
						input: false,
						submit: false,
						finish: false
					}

					self_.stepNumber_--;
					
					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_slsInpLyt_top')
				})
			},
			$_slsInpLyt_submit() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						serialNumber: false,
						input: false,
						submit: true,
						finish: false
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						serialNumber: true,
						input: true,
						submit: false,
						finish: false
					}

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_slsInpLyt_top')
				}).catch(error => {
					self_.errorMessage_ = error;
					vuetify_.goTo('#_slsInpLyt_top')
				})
			},
			$_slsInpLyt_confirm() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				// prevent double-click of confirm button
				if(self_.onProgress_) { return }
				else {
					self_.onProgress_ = true;
				}

				const sales_ = self_.$_slsInpLyt_stateUserSales;

				let array_ = []

				Object.keys(sales_).forEach(key=> {
					const product_ = sales_[key].addedProduct;
					
					Object.keys(product_).forEach(productKey => {
						array_.push({
							merchantId: key,
							productId: productKey
						})
					})
					
					const number_ = sales_[key].addedSerialNumber;

					Object.keys(number_).forEach(numberKey => {
						array_.push({
							merchantId: key,
							productId: number_[numberKey].productId,
							serialNumber: number_[numberKey].serialNumber
						})
					})
				})

				self_.setInputState('sales', array_)

				let salesInfo_ = {}
				salesInfo_.subTotal = self_.subTotal_;
				salesInfo_.tax = self_.tax_;
				salesInfo_.total = self_.total_;

				self_.setInputState('salesInfo', salesInfo_)

				let id_ = null;

				// add input & message
				Promise.resolve().then(() => {
					return self_.addInput()
				}).then(result => {
					id_ = result.id
					return self_.addInputData(id_)
				}).then(() => {
					return self_.addInputSales(id_)
				}).then(() => {
					return self_.$_slsInpLyt_updateSerialNumberState()
				}).then(() => {
					// message
					const uid_ = self_.$_slsInpLyt_currentUserUid;
					const contact_ = self_.$_slsInpLyt_infoContactUid;

					// title
					self_.setMessageState('title', 'Input received.')

					// text
					self_.setMessageState('text', 'Input Key is ' + id_)

					// sender
					self_.setMessageState('sender', uid_)

					// to
					self_.setMessageState('to', contact_)

					// user
					let user_ = {}
					user_[uid_] = true;
					user_[contact_] = true;
					
					return self_.addMessage()
				}).then(() => {
					self_.mode_ = { 
						serialNumber: false,
						input: false,
						submit: false,
						finish: true
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						serialNumber: true,
						input: true,
						submit: true,
						finish: false
					}

					self_.onProgress_ = false;

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_slsInpLyt_top')
				}).catch(error => {
/* error */			self_.logError('Error', '$_slsInpLyt_confirm()', error)
				})
			},
			$_slsInpLyt_calcTotal() {
				const self_ = this;
				
				const sales_ = self_.getUserState('sales')

				let resultProduct_ = 0;
				let resultSerialNumber_ = 0;

				Object.keys(sales_).forEach(merchantKey => {
					const product_ = sales_[merchantKey].addedProduct;
					const serialNumber_ = sales_[merchantKey].addedSerialNumber;

					if(self_.isObject(product_)) {
						Object.keys(product_).forEach(productKey => {
							if(self_.isFalse(product_[productKey].serialNumbers)) {
								resultProduct_ += (product_[productKey].price * product_[productKey].amount)
							}
						})
					}

					if(self_.isObject(serialNumber_)) {
						Object.keys(serialNumber_).forEach(serialNumberKey => {
							resultSerialNumber_ += serialNumber_[serialNumberKey].price;
						})
					}
				})

				self_.subTotal_ = resultProduct_ + resultSerialNumber_;
				self_.tax_ = self_.subTotal_ * 0.1;
				self_.total_ = self_.subTotal_ + self_.tax_;
			},
			$_slsInpLyt_updateSerialNumberState() {
				const self_ = this;

				const sales_ = self_.getUserState('sales')
				
				const update_ = (merchantId, productId, serialNumber) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubSubDocument('sales', merchantId, 'products', productId, 'serialNumbers', serialNumber)
					}).then(result => {
						result.status.used = true

						return self_.setFirestoreSubSubDocument('sales', merchantId, 'products', productId, 'serialNumbers', serialNumber, result)
					})
				}

				let promiseArray_ = []

				Promise.resolve().then(() => {
					Object.keys(sales_).forEach(merchantId => {
						const serialNumber_ = sales_[merchantId].addedSerialNumber;

						Object.keys(serialNumber_).forEach(key => {
							const product_ = serialNumber_[key].productId;

							promiseArray_.push(update_(merchantId, product_, key))
						})
					})
					return
				}).then(() => {
					return Promise.all(promiseArray_)
				})
			}
		}
	}
</script>

<style scoped>
	.cardText_ {
		padding-top: 0;
	}
	.stepper_ {
		box-shadow: none;
		background-color: transparent;
	}
	.stepperHeader_ {
		background-color: transparent;
		box-shadow: none;
		height: 80px;
	}
	.stepperItem_ {
		background-color: transparent;
		box-shadow: none;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
